import React, { useState } from 'react'
import { useRouteMatch } from 'react-router-dom'
import { useVersioning } from 'modules/versioning'
import debounce from 'debounce'
import Filter from 'components/Filter'
import {
  TopNavigationList,
  TopNavigationLink,
  Container,
  SearchContainer,
} from './Header.styles'
import { useFlag } from 'constants/flags'
import {
  isDocumentRoute,
  isDocumentPageRoute,
} from 'components/Breakpoint/utils'
import { useForTablet } from 'components/Breakpoint'
import { isCwvSpecificRoute } from 'modules/shares/ComponentsWebView/CwvRoutes'
import { MobileHeader } from './MobileHeader'

export const Header: React.FC<{
  shareID: string
  isSidebarRightOpen: boolean
  setSearchCwv: (search: string) => void
}> = ({ shareID, isSidebarRightOpen, setSearchCwv }) => {
  const [inputValue, setInputValue] = useState('')
  const isComponentsWebViewOn = useFlag('components-web-view')
  const isTabletScreen = useForTablet()
  const { path } = useRouteMatch()
  const { versionShortId } = useVersioning()

  if (!isComponentsWebViewOn) {
    return null
  }

  const routeParams = {
    shareID,
    versionShortId,
  }

  const handleInputValueUpdate = (inputValue: string) => {
    setInputValue(inputValue)

    if (inputValue === '') {
      // clear immediately
      setSearchCwv('')
      return
    }

    debounce(() => {
      setSearchCwv(inputValue)
    }, 500)()
  }

  if (!isTabletScreen) {
    return (
      <MobileHeader
        shareID={shareID}
        setSearchCwv={handleInputValueUpdate}
        path={path}
        versionShortId={versionShortId}
        isSidebarRightOpen={isSidebarRightOpen}
      />
    )
  }

  return (
    <Container pt={2} pl={3} pb={2} isSidebarRightOpen={isSidebarRightOpen}>
      <TopNavigationList>
        <li>
          <TopNavigationLink
            selected={isDocumentRoute(path) || isDocumentPageRoute(path)}
            to={{
              routeKey: 'SHARE_VIEW',
              routeParams,
            }}>
            Pages
          </TopNavigationLink>
        </li>
        <li>
          <TopNavigationLink
            selected={isCwvSpecificRoute(path, 'CWV_SYMBOLS')}
            to={{
              routeKey: 'CWV_SYMBOLS',
              routeParams,
            }}>
            Symbols
          </TopNavigationLink>
        </li>
        <li>
          <TopNavigationLink
            selected={isCwvSpecificRoute(path, 'CWV_TEXT_STYLES')}
            to={{
              routeKey: 'CWV_TEXT_STYLES',
              routeParams,
            }}>
            Text Styles
          </TopNavigationLink>
        </li>
        <li>
          <TopNavigationLink
            selected={isCwvSpecificRoute(path, 'CWV_LAYER_STYLES')}
            to={{
              routeKey: 'CWV_LAYER_STYLES',
              routeParams,
            }}>
            Layer Styles
          </TopNavigationLink>
        </li>
        <li>
          <TopNavigationLink
            selected={isCwvSpecificRoute(path, 'CWV_COLOR_VARIABLES')}
            to={{
              routeKey: 'CWV_COLOR_VARIABLES',
              routeParams,
            }}>
            Color Variables
          </TopNavigationLink>
        </li>
      </TopNavigationList>
      <SearchContainer>
        <Filter
          placeholder="Search Components"
          onChange={handleInputValueUpdate}
          value={inputValue}
          isCWV
        />
      </SearchContainer>
    </Container>
  )
}
